import DataPicker from '../Date/DatePicker';
import DropdownAction from '../Actions/DropdownAction';
import SearchBox from '../Actions/SearchBox';
import { Key } from 'react';

function SearchTable({
  labelSelect,
  searchText,
  getDate,
  onSearchName,
  searchType,
  searchFilter,
  labelSearchType,
  labelSearchFilter,
  menu,
  isReturn,
  isBilling
}: any) {
  const getDateTime = (startDate: string, endDate: string) => {
    getDate(startDate, endDate);
  };

  const onChangeSearch = (e: string) => {
    searchText(e);
  };

  const searchNameText = () => {
    onSearchName();
  };
  return (
    <div
      className="wrapActions"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px '
      }}
    >
      <DataPicker getDate={getDateTime} />
      {isReturn && <p style={{ marginBottom: '0' }}>Retransfer/Disposal</p>}
      {isBilling && <p style={{ marginBottom: '0' }}>Status</p>}
      {menu?.map((item: { id: Key | null | undefined; list: JSX.Element }) => {
        return (
          <DropdownAction
            key={item.id}
            titleSelect={labelSelect.label}
            list={item.list}
          />
        );
      })}
      {searchType?.map(
        (item: { id: Key | null | undefined; list: JSX.Element }) => {
          return (
            <DropdownAction
              key={item.id}
              titleSelect={labelSearchType?.label}
              list={item.list}
            />
          );
        }
      )}
      {searchFilter?.map(
        (item: { id: Key | null | undefined; list: JSX.Element }) => {
          return (
            <DropdownAction
              key={item.id}
              titleSelect={labelSearchFilter?.label}
              list={item.list}
            />
          );
        }
      )}

      <SearchBox
        getText={onChangeSearch}
        type="false"
        onSearchName={searchNameText}
      />
    </div>
  );
}

export default SearchTable;
